import { ExceptionTypes, ExceptionUtils } from '@frontend/api-schedule-exceptions';
import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';
import { CompactTable } from '../compact-table';
import { ExceptionAvailabilityCellValue, ExceptionTimeCellValue } from './exceptions-table-cell-values';

const { getDisplayDate } = ExceptionUtils;

export const ScheduleExceptionsExpandedRow = ({ exceptionData }: { exceptionData: ExceptionTypes.ExceptionData }) => {
  const { t } = useTranslation('schedule');

  return (
    <CompactTable.ExpandedRow>
      <CompactTable.InfoRow label={t('Name')} value={exceptionData.name} />
      <CompactTable.InfoRow
        label={t('Availability')}
        value={<ExceptionAvailabilityCellValue isAvailable={exceptionData.isAvailable} />}
      />
      <CompactTable.InfoRow
        label={t('Date')}
        value={<Text as='span'>{getDisplayDate(exceptionData.startDate, exceptionData.endDate)}</Text>}
      />
      <CompactTable.InfoRow
        label={t('Time')}
        value={<ExceptionTimeCellValue startTime={exceptionData.startTime} endTime={exceptionData.endTime} />}
      />
    </CompactTable.ExpandedRow>
  );
};
